/**
 * SEO: product card links are rendered with a clean href (no ?variant=) so
 * crawlers consolidate signals on the canonical product URL. This handler
 * restores the variant preselect for real users at click time.
 *
 * Anchors opt in via [data-variant-link] and carry the variant in
 * [data-variant-id]. Modified clicks (new tab, download, etc.) are left
 * alone and fall back to the clean product URL.
 */
document.addEventListener('click', (event) => {
  const link = event.target?.closest?.('a[data-variant-link]');
  if (!link) return;
  if (event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  if (link.target && link.target !== '_self') return;
  if (link.hasAttribute('download')) return;

  const containerSelector = '.featured-card-product, .product-card, product-info';
  const container = link.closest(containerSelector);
  const selectedInput = container && Array.from(container.querySelectorAll('.product-variant-id'))
    .find((input) => input.closest(containerSelector) === container);
  if (selectedInput && !selectedInput.value) return;
  const variantId = selectedInput ? selectedInput.value : link.dataset.variantId;

  let url;
  try {
    url = new URL(link.dataset.variantUrl || link.href, window.location.href);
  } catch (error) {
    return;
  }
  if (url.origin !== window.location.origin || !['http:', 'https:'].includes(url.protocol)) return;
  if (variantId) url.searchParams.set('variant', variantId);
  if (url.href === link.href) return;

  event.preventDefault();
  window.location.assign(url.toString());
});
